$(document).ready( function() {
    if($('#location-map').length > 0) {
        var canvas = $('#location-map');
        var lat = canvas.data('lat');
        var long = canvas.data('long');
        var title = canvas.data('title');
        SingleMapSetup(lat,long,title);
    }
    if($('#all-locations').length > 0) {
        var canvas = $('#all-locations');
        var data = canvas.data('locations');
        ClusterMapSetup(data);
    }
});

var styles = [
    {
        "featureType": "all",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#9d9d9d",
                "lightness": 0
                
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": "25"
            },
            {
                "weight": "4.62"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "gamma": 0.01
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "saturation": -31
            },
            {
                "lightness": -33
            },
            {
                "weight": 2
            },
            {
                "gamma": 0.8
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "all",
        "stylers": [
            {
                "color": "#ab080e"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "lightness": -20
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#e7e7e8"
            }
        ]
    },

    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#6b6a6a"
            }
        ]
    }
]

var clusterStyles = [
    {
        "featureType": "all",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#9d9d9d",
                "lightness": 0
                
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "lightness": "25"
            },
            {
                "weight": "4.62"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "gamma": 0.01
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "saturation": -31
            },
            {
                "lightness": -33
            },
            {
                "weight": 2
            },
            {
                "gamma": 0.8
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "all",
        "stylers": [
            {
                "color": "#ab080e"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "lightness": -20
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#e7e7e8"
            }
        ]
    },

    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#e7e7e8"
            }
        ]
    }
]



var icon = '/_resources/app/client/assets/images/icons/map-marker.png';

function SingleMapSetup(lat,long,title) {

    // styles.push(
        
    // );

    var myLatlng = new google.maps.LatLng(lat,long);
    var mapOptions = {
        zoom: 16,
        styles: styles,
        center: myLatlng,
        scrollwheel: false,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    };
    var map = new google.maps.Map(
        document.getElementById('location-map'),
        mapOptions
    );
    var marker = new google.maps.Marker({
        position: myLatlng,
        title:'Gilmours ' + title,
        icon: icon,
    });
    marker.setMap(map);

    // Add custom zoom controls
    var zoomControlDiv = document.createElement('div');
    var zoomControl = new ZoomControl(zoomControlDiv, map);
    zoomControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(zoomControlDiv);
}

// Global markers array.
var markers = [];

function ClusterMapSetup(data) {

    var markerCounter = 0;
    var singleMapCenter;
    var mapOptions = {
        zoom: 6,
        styles: clusterStyles,
        scrollwheel: false,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    }

    var map = new google.maps.Map(
        document.getElementById('all-locations'),
        mapOptions
    );

    // Add custom zoom controls
    var zoomControlDiv = document.createElement('div');
    var zoomControl = new ZoomControl(zoomControlDiv, map);
    zoomControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.TOP_LEFT].push(zoomControlDiv);

    // Create the map bounds object. Only used if the map has more than one marker.
    var bounds = new google.maps.LatLngBounds();
    
    // Loop through all locations and create markers.
    $.each(data, function(i, item){
        markerCounter++;

        // Create the marker object
        var marker = new google.maps.Marker({
            position: {lat: parseFloat(item.Lat), lng: parseFloat(item.Long)},
            title: 'Gilmours ' + item.Title,
            icon: icon,
            map: map,
            url: item.URL
        });

        // Set marker id and add own function.
        marker.set('id', item.ID);
        // marker.set('toggleIcon', function(){
        //     map.panTo(marker.getPosition());
        // });

        // on click of marker, go to location page
        marker.addListener('click', function() {
            window.location.href = this.url;
        });

        // Populate the markers array.
        markers.push(marker);


        // Add marker positions to bounds object.
        bounds.extend({lat: parseFloat(item.Lat), lng: parseFloat(item.Long)});

        // This is used if there is only one marker in the map.
        singleMapCenter = {lat: parseFloat(item.Lat), lng: parseFloat(item.Long)};
    });

    // Only fitBounds if there is more than one marker.
    if(markerCounter > 1) {
        map.fitBounds(bounds, 100);
    } else{
        map.setCenter(singleMapCenter);
    }

}

function ZoomControl(controlDiv, map) {

    // Creating divs & styles for custom zoom control
    controlDiv.style.borderRight = '1px solid #e7e7e8';
    controlDiv.style.borderBottom = '1px solid #e7e7e8';

    // Set CSS for the control wrapper
    var controlWrapper = document.createElement('div');
    controlWrapper.style.cursor = 'pointer';
    controlWrapper.style.textAlign = 'center';
    controlWrapper.style.width = '60px'; 
    controlWrapper.style.height = '120px';
    controlDiv.appendChild(controlWrapper);

    // Set CSS for the zoomIn
    var zoomInButton = document.createElement('div');
    zoomInButton.style.width = '60px'; 
    zoomInButton.style.height = '60px';
    zoomInButton.style.background = 'url("/_resources/app/client/assets/images/icons/map-zoom-in.png") center center no-repeat #d71921';
    controlWrapper.appendChild(zoomInButton);

    // Set CSS for the zoomOut
    var zoomOutButton = document.createElement('div');
    zoomOutButton.style.width = '60px'; 
    zoomOutButton.style.height = '60px';
    zoomOutButton.style.background = 'url("/_resources/app/client/assets/images/icons/map-zoom-out.png") center center no-repeat #faa61a';
    controlWrapper.appendChild(zoomOutButton);

    // Setup the click event listener - zoomIn
    google.maps.event.addDomListener(zoomInButton, 'click', function() {
        map.setZoom(map.getZoom() + 1);
    });

    // Setup the click event listener - zoomOut
    google.maps.event.addDomListener(zoomOutButton, 'click', function() {
        map.setZoom(map.getZoom() - 1);
    }); 
}